import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'
import { perPageItem } from '../../../utils'

import feedback from './feedback'
import signUp from './signUp'
import feedbackDetail from '@/store/modules/activity/feedbackDetail'

const state = {
  detail: {
    id: '',
    title: '',
    address: '',
    address_city: '',
    address_area: '',
    is_free: true,
    limit_number_of_user: null,
    publish_time: null,
    session_time_id: null,
    signed_up_user_count: null,
    signed_in_count: 0,
    signin_start_time: 0,
    signin_end_time: 0,
    update_at: null,
    current_session_time_sign_in_count: 0,
    current_session_time_sign_in: {}
  },
  signUp: null,
  signUps: [],
  signUpCount: 0,
  loaded: false,
  list: [],
  currentPage: 1,
  hasMore: true,
  qrcode: '',
  qrcodeModalVisible: false
}

const actions = {
  [aTypes.ACTIVITY_GET_LIST] ({ commit, dispatch }, { page, append }) {
    commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_GET_LIST, loading: true })
    api.activity.getList({
      success (res) {
        const list = res.body.data
        const pagination = res.body.meta.pagination
        const hasMore = pagination.current_page < pagination.total_page
        commit(mTypes.ACTIVITY_SET_LIST, { list, page, hasMore, append })
        commit(mTypes.SET_LOADED_OF_ACTIVITY_LIST, true)
        commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_GET_LIST, loading: false })
        dispatch(aTypes.ZHUGE_TRACK, { event: '到达活动列表页' })
      },
      commit
    }, { page, perPage: perPageItem })
  },
  [aTypes.ACTIVITY_GET_DETAIL] (context, { activityId }) {
    context.commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_GET_DETAIL, loading: true })
    api.activity.getOne({
      success (res) {
        context.commit(mTypes.ACTIVITY_SET_DETAIL, res.body)
      }
    }, activityId)
  },
  // 短轮询活动计数,报名&签到人数
  [aTypes.ACTIVITY_GET_COUNT] (context, { activityId }) {
    new Promise((resolve) => {
      return api.activity.getActivityCount({
        success: resolve
      }, { activityId })
    }).then(res => {
      context.commit(mTypes.ACTIVITY_SET_COUNT, res.body)
    })
  }
}

const mutations = {
  [mTypes.ACTIVITY_SET_LIST] (state, { list, page, hasMore, append }) {
    if (append) {
      state.list = state.list.concat(list)
    } else {
      state.list = list
    }
    state.currentPage = page
    state.hasMore = hasMore
  },
  [mTypes.ACTIVITY_SET_DETAIL] (state, payload) {
    state.detail = payload
  },
  [mTypes.ACTIVITY_SET_SIGN_UP] (state, payload) {
    state.signUp = payload
  },
  [mTypes.ACTIVITY_SET_SIGN_UPS] (state, payload) {
    state.signUps = payload.signUps
    state.signUpCount = payload.signUpCount
    state.loaded = true
  },
  [mTypes.ACTIVITY_RESET_SIGN_UP] (state) {
    state.signUps = []
    state.signUpCount = 0
    state.loaded = false
  },
  [mTypes.ACTIVITY_SET_COUNT] (state, payload) {
    state.detail.current_session_time_sign_in_count = payload.current_session_time_sign_in_count
    state.detail.signed_in_count = payload.signed_in_count
  },
  [mTypes.ACTIVITY_SET_SCAN_QRCODE] (state, payload) {
    state.qrcode = payload
  },
  [mTypes.ACTIVITY_SET_SCAN_QRCODE_MODAL_VISIBLE] (state, payload) {
    state.qrcodeModalVisible = payload
  }
}

export default {
  modules: {
    signUp,
    feedback,
    feedbackDetail
  },
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/activity/index.js